import {createSelector, createSlice} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';
import {DIRECTORIES_COMPANY_SLICE} from 'store/slices/directories-company-slice/directories-company-slice-constants';
import {loadAisSignatoriesByOrgId} from 'store/slices/directories-company-slice/directories-company-slice-thunks';
import {TDirectoriesCompanySliceState} from 'store/slices/directories-company-slice/directories-company-slice-types';

export const directoriesCompanySlice = createSlice({
    name: DIRECTORIES_COMPANY_SLICE,
    initialState: {
        aisSignatories: undefined,
    } as TDirectoriesCompanySliceState,
    reducers: {
        resetAisSignatories(state) {
            state.aisSignatories = undefined;
        },
    },
    extraReducers: builder => {
        builder.addCase(loadAisSignatoriesByOrgId.fulfilled, (state, action) => {
            state.aisSignatories = action.payload;
        });
    },
});

const selectDirectoriesCompanySliceState = (state: TAppState) => state[DIRECTORIES_COMPANY_SLICE];

export const directoriesCompanySelectors = {
    selectAisSignatories: createSelector(
        selectDirectoriesCompanySliceState,
        state => state.aisSignatories,
    ),
};

export const {
    reducer: directoriesCompanyReducer,
    actions: directoriesCompanyActions,
} = directoriesCompanySlice;
